module.exports = " <div class=\"facet multi-facet\" :class=\"{ error: !this.valid, required: facet.required }\"> <h5>{{ facet.name }}</h5> <ul class=options> <li v-for=\"choice in choices\" :class=classes(choice) :key=choice.id @click=toggle(choice)> {{ choice.value }} <price-modifier :choice=choice></price-modifier> </li> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MultiFacet.vue
// module id = 368
// module chunks = 2